import Plyr from 'plyr';
import Hero from './sections/hero';
import Slider from './sections/slider';
import Grid from './sections/grid';
import loadMore from './modules/readmore';
import Team from './sections/team';
import MailchimpSuscription from './modules/mailchimpSubscription';
// import barba from '@barba/core';
import gsap from 'gsap';

gsap.to('#main', {
  autoAlpha: 1,
  duration: 0.4,
  ease: 'linear',
  onComplete: function () {
    // console.log('done');
    document.body.classList.add('loaded');
  }
});

/* Is Touch*/
window.isTouchDevice = isTouchDevice();

/* Mailchimp */
const mailchimpSuscription = new MailchimpSuscription();

function isTouchDevice() {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

/* TODO: Add intersection observer pollyfill */
const observerOptions = {
  root: null,
  rootMargin: '0px',
  threshold: 0.1
};
const observerCallback = (entries) => {
  entries.forEach((entry) => {
    // if (entry.target.id == "myvideo") {
    if (
      entry.isIntersecting &&
      !entry.target.classList.contains('playing') &&
      !entry.target.classList.contains('disabled')
    ) {
      if (entry.target) {
        const playPromise = entry.target.play();
        if (playPromise !== undefined) {
          playPromise.then((_) => {}).catch((error) => {});
        }
        entry.target.classList.add('playing');
      }
    }
    if (!entry.isIntersecting && entry.target.classList.contains('playing')) {
      const pausePromise = entry.target.pause();
      if (pausePromise !== undefined) {
        pausePromise.then((_) => {}).catch((error) => {});
      }
      entry.target.classList.remove('playing');
    }
    // }
  });
};

let revealElements = document.querySelectorAll('.reveal-element'); // Define the elements you want to intiate an action on

const revealObserveroptions = {
  //define your options
  threshold: 0
};

const inViewCallback = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      // define the event/property you want to use
      //do something with the element, in our case, add a class
      entry.target.classList.add('inview');
    } else {
      // OPTIONAL, in case you want to do something once the intersection is done
    }
  });
};

// create a new instance using our callback which contains our elements and actions, using the options we defined
let inviewObserver = new IntersectionObserver(
  inViewCallback,
  revealObserveroptions
);

revealElements.forEach((element) => {
  inviewObserver.observe(element); // run the observer
});

// if (window.isMobile) {
//     if (currentSection) {
//         videosToObserve = currentSection.querySelectorAll(
//             ".js-mobile-autoplay"
//         );
//     } else {
//         videosToObserve = document.querySelectorAll(".js-mobile-autoplay");
//     }
// }

// Function to add and remove the page transition screen
// function pageTransitionIn(container) {
//     return gsap.to(container, { duration: 0.1, autoAlpha: 1 })
// }

// // Function to add and remove the page transition screen
// function pageTransitionOut(container) {
//     return gsap.from(
//         container,{
//         autoAlpha: 0,
//         ease: 'power1.out'
//     });

// }

// barba.init({
//     transitions: [{
//       name: 'opacity-transition',
//       async leave(data) {
//         await pageTransitionIn(data.current.container.querySelector('#main'))
//         data.current.container.remove()
//         window.scrollTo({top: 0, behavior: "auto"});
//       },

//       async enter(data) {
//         initPage();
//         await pageTransitionOut(data.next.container.querySelector('#main'))
//       },
//     }]
// });

initPage();

function initPage() {
  const heroInstance = new Hero();

  /* Sliders */
  const sliderInstance = new Slider('.default-slider', 5000);

  /* Grids */
  const gridInstance = new Grid();

  /* Load More */
  const loadMoreInstance = new loadMore();

  /* Team */
  const teamInstance = new Team();

  /* Player */
  const observer = new IntersectionObserver(observerCallback, observerOptions);
  let videosToObserve;

  videosToObserve = document.querySelectorAll('.js-autoplay');

  if (videosToObserve) {
    videosToObserve.forEach((videoToObserve) => {
      observer.observe(videoToObserve);
    });
  }

  const plyrEls = document.querySelectorAll('.js-player');
  if (plyrEls) {
    plyrEls.forEach(function (plyr) {
      const player = new Plyr(plyr);
    });
  }

  var clickToggles = document.querySelectorAll('[data-action]');
  clickToggles.forEach((clickToggle) => {
    clickToggle.addEventListener('click', function (e) {
      e.preventDefault();
      let idToToggle = clickToggle.getAttribute('data-action');
      let textIdToToggle = clickToggle.getAttribute('data-text-toggle');
      let toggleTarget = document.getElementById(idToToggle);
      let texToggle = document.getElementById(textIdToToggle);
      if (toggleTarget) {
        const headerInitialText = texToggle.getAttribute('data-init-text');
        const headerCloseText = texToggle.getAttribute('data-close-text');

        document
          .getElementById('header')
          .classList.toggle('mix-blend-difference');
        document.body.classList.toggle('contact-is-active');
        toggleTarget.classList.toggle('opacity-0');
        toggleTarget.classList.toggle('pointer-events-none');
        if (headerInitialText && headerCloseText) {
          if (toggleTarget.classList.contains('opacity-0')) {
            texToggle.innerHTML = headerInitialText;
          } else {
            texToggle.innerHTML = headerCloseText;
          }
        }
      }
    });
  });

  console.log('init cookie consent', bannerEnabled);
  if (bannerEnabled) {
    initCookieControlBanner();
  }
  function initCookieControlBanner() {
    var cc = initCookieConsent();

    cc.run({
      current_lang: 'en',
      autoclear_cookies: true, // default: false
      page_scripts: true, // default: false                        // default: 0

      onAccept: function (cookie) {
        // ...
      },

      onChange: function (cookie, changed_preferences) {
        // ...
      },

      languages: {
        es: {
          consent_modal: {
            description:
              'Utilizamos Cookies propias y de terceros para mejorar tu experiencia como usuario y captar datos estadísticos. Al hacer clic en "Aceptar" prestas tu consentimiento para el uso de Cookies. Puedes consultar nuestra política de Cookies <a class="c-bn" target="_blank" href="" style="display: inline">aquí</a>. Puedes <button type="button" data-cc="c-settings" class="cc-link">Configurar</button>, <button type="button" id="c-s-bn" data-cc="accept-necessary" class="c-bn c_link">Rechazar</button> o <button type="button" id="c-p-bn" data-cc="accept-all" class="c-bn">Aceptar</button> las Cookies.'
          },
          settings_modal: {
            title: 'Cookie preferences',
            save_settings_btn: 'Save settings',
            accept_all_btn: 'Accept all',
            reject_all_btn: 'Reject all',
            close_btn_label: 'Close',
            cookie_table_headers: [
              { col1: 'Name' },
              { col2: 'Domain' },
              { col3: 'Expiration' },
              { col4: 'Description' }
            ],
            blocks: [
              {
                title: 'Cookie usage',
                description:
                  'We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies or queries in relation to our policy and your choices, please read the full <a href="/privacy-policy/" class="cc-link">privacy policy</a>.'
              },
              {
                title: 'Strictly necessary cookies',
                description:
                  'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly',
                toggle: {
                  value: 'necessary',
                  enabled: true,
                  readonly: true // cookie categories with readonly=true are all treated as "necessary cookies"
                }
              },
              {
                title: 'Performance and Analytics cookies',
                description:
                  'These cookies allow the website to remember the choices you have made in the past',
                toggle: {
                  value: 'analytics', // your cookie category
                  enabled: false,
                  readonly: false
                },
                cookie_table: [
                  // list of all expected cookies
                  {
                    col1: '^_ga', // match all cookies starting with "_ga"
                    col2: 'google.com',
                    col3: '2 years',
                    col4: 'description ...',
                    is_regex: true
                  },
                  {
                    col1: '_gid',
                    col2: 'google.com',
                    col3: '1 day',
                    col4: 'description ...'
                  }
                ]
              }
            ]
          }
        }
      }
    });
  }
}

(function () {
  if ('loading' in HTMLImageElement.prototype) {
    var lazyImages = document.querySelectorAll('img[loading="lazy"]');
    for (var img of lazyImages) {
      if (!img.complete) {
        img.classList.add('lazyImageWaiting');
        img.addEventListener('load', lazyImageLoad, false);
        img.addEventListener('error', lazyImageError, false);
      }
    }

    function lazyImageLoad(e) {
      e.currentTarget.classList.remove('lazyImageWaiting');
      e.currentTarget.classList.add('lazyLoaded');
    }

    function lazyImageError(e) {
      var parent = e.currentTarget;
      parent.classList.remove('lazyImageWaiting');
      parent.classList.add('lazyImageError');
      setTimeout(function () {
        parent.classList.add('lazyImageErrorShow');
      }, 60);
    }
  } // if 'loading' supported
})();
